import LocationScreen from './index';

const routes = [
  {
    path: '/master/location',
    component: LocationScreen,
    action: ['manage', 'read_only'],
    service: ['nvo.platform.location'],
  },
];

export default routes;
